<!--
 * @Description: 头部通用组件
 * @Author: youme
 * @LastEditors: 5CD2160XDH\shijun shijun1@haosen.com.cn
 * @Date: 2020-06-12 08:57:46
 * @LastEditTime: 2024-07-16 15:21:35
-->
<template>
  <div>
    <div class="hidden-md-and-down">
      <div class="container">
        <div class="head-body">
          <div class="head-links">
            <div class="head-up">
              <div class="sale-phone">销售热线：15754006669/0411-39516699</div>
              <!-- <div>售后服务：15754006667/0411-39516676</div> -->
              <div class="contact-us" @click="handleChoseThird('/contact')">联系我们</div>
              <!-- <div>EN / CN</div>
              <div class="vertical" />
              <img :src="user" alt="user">
              <div>登录</div> -->
            </div>
            <div class="head-down">
              <img
                class="img-over"
                :src="logo"
                alt="logo"
                :style="{ cursor: $route.path === '/' ? 'auto': 'pointer' }"
                @click="handleChoseThird('/')"
              >
              <div class="links">
                <div :class="{ 'home-link': hoverNavIndex === -1 && $route.path === '/' }" @click="handleChoseThird('/')" @mouseover="handleNavHoverIndex(-1)">首页</div>
                <div
                  v-for="(link, index) in links"
                  :key="index"
                  :class="{'home-link': hoverNavIndex === link.index}"
                  @mouseover="handleShow(link.index)"
                  @mouseout="handleHide"
                >
                  {{ link.text }}
                </div>
                <div :class="{'home-link': hoverNavIndex === 4 }" @click="handleChoseThird('/contact')" @mouseover="handleNavHoverIndex(4)">联系我们</div>
              </div>
              <div class="free-trial" @click="() => handleShowFormModal(true)">免费体验</div>
              <div class="second-menus" :style="showSecondMenu" @mouseover="handleShow" @mouseout="handleHide">
                <div class="link-items" :style="[flexStyle]">
                  <!-- <div v-if="menu" class="group-item">
                    <div class="text-normal" @click="handleChoseThird(menu.url)">{{ menu.name }}</div>
                  </div> -->
                  <div v-if="formattedMenus.level === 3" :style="flexStyle">
                    <div v-for="menu in formattedMenus.children" :key="menu.name" :class="{'item': true }">
                      <div v-if="!menu.hidden" class="text-title">{{ menu.name }}</div>
                      <div v-for="(group, index) in menu.children" :key="index" class="group-item">
                        <div v-for="(link, keyIndex) in group" :key="keyIndex" class="link-info" @click="handleChoseThird(link.url)">
                          <div class="icon-wrapper">
                            <img v-if="link.iconUrl" :src="link.iconUrl" alt="icon" class="icon-normal">
                          </div>
                          <div class="text-normal">{{ link.name }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="menu-level-2-wrapper" :style="[flexStyle]">
                  <!-- <div v-if="menu" class="group-item">
                    <div class="text-normal" @click="handleChoseThird(menu.url)">{{ menu.name }}</div>
                  </div> -->
                  <div v-if="formattedMenus.level === 2" :class="{'item': true }" :style="flexStyle">
                    <div v-for="(menuList, menuListIndex) in formattedMenus.children" :key="menuListIndex" class="menu-level-2">
                      <div v-for="(menu, index) in menuList" :key="index" class="menu-item-wrapper">
                        <div v-if="menu.url" class="text-normal" @click="handleChoseThird(menu.url)">{{ menu.name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden-lg-and-up fix-body">
      <div class="container navigation-mobile">
        <img class="img-show" :src="logoPhone" alt="logo" @click="handleChoseThird('/')">
        <i class="el-icon-s-fold" @click="showFirst = true" />
      </div>
    </div>
    <Drawer
      :visible.sync="showFirst"
      :show-close="false"
      size="300px"
      class="navigation-mobile"
    >
      <template v-slot:title>
        <div class="navigation-title">
          <div style="height: 1px;width: 22px" />
          <div>首页</div>
          <i class="el-icon-close" @click="showFirst = false" />
        </div>
      </template>
      <div v-for="(menu, index) in menus" :key="menu.name" class="navigation-text" @click="handleChoseFirst(index)">{{ menu.name }}<i class="el-icon-arrow-right" /></div>
      <Drawer
        :visible.sync="showSecond"
        :show-close="false"
        :append-to-body="true"
        class="navigation-mobile"
        size="300px"
      >
        <template v-slot:title>
          <div class="navigation-title">
            <i class="el-icon-arrow-left" @click="showSecond = false" />
            <div>{{ showSecondTitle }}</div>
            <i class="el-icon-close" @click="showSecond = false" />
          </div>
        </template>
        <div v-for="(menu, index) in showSecondMenus" :key="menu.name" class="navigation-text" @click="handleChoseSecond(index)">{{ menu.name }}<i class="el-icon-arrow-right" /></div>
        <Drawer
          :visible.sync="showThird"
          :show-close="false"
          :append-to-body="true"
          class="navigation-mobile"
          size="300px"
        >
          <template v-slot:title>
            <div class="navigation-title">
              <i class="el-icon-arrow-left" @click="showThird = false" />
              <div>{{ showThirdTitle }}</div>
              <i class="el-icon-close" @click="showThird = false" />
            </div>
          </template>
          <div v-for="menu in showThirdMenus" :key="menu.name" class="navigation-text" @click="handleChoseThird(menu.url)">{{ menu.name }}<i class="el-icon-arrow-right" /></div>
        </Drawer>
      </Drawer>
    </Drawer>
    <div v-if="visible" class="video-body" @mousewheel.prevent="handleScroll">
      <div class="back-shadow" @click="() => handleSwitchVideo(false)" />
      <div class="video-show">
        <div class="close-body" @click="() => handleSwitchVideo(false)" />
        <video width="900" height="506" controls autoplay>
          <source src="/mp4/mom.mov" type="video/mp4">
          您的浏览器不支持观看视频。
        </video>
      </div>
    </div>
    <TrialForm :show-free-trial="showFreeTrial" @handleShowFormModal="handleShowFormModal" />
  </div>
</template>

<script>
import { Drawer } from 'element-ui'
import trialTop from '@/assets/freeTrial/free-trial-top.png'
import logo from '@/assets/home/head-logo.png'
import logoPhone from '@/assets/home/logo.svg'
import user from '@/assets/home/user.png'
import { menus, links } from '../config'
import cloneDeep from 'lodash/cloneDeep'
import chunk from 'lodash/chunk'
import TrialForm from '@/components/TrialForm'
import { getSolutionMenu } from '../api'

export default {
  name: 'Head',
  components: {
    Drawer,
    TrialForm
  },
  data: function() {
    return {
      trialTop,
      logo,
      logoPhone,
      user,
      title: '产品',
      menus,
      links,
      show: false,
      showMenu: menus[0],
      showFirst: false,
      showSecond: false,
      showSecondMenus: [],
      showSecondTitle: '',
      showThird: false,
      showThirdMenus: [],
      showThirdTitle: '',
      visible: false,
      hoverNavIndex: -1,
      showFreeTrial: false,
      form: {},
      rules: {
        name: [
          { pattern: /^[\u4e00-\u9fa5]{0,}$/, message: '请输入正确的姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { pattern: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/, message: '请输入正确的电话', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    formattedMenus: function() {
      const menus = cloneDeep(this.showMenu)
      return {
        ...menus,
        children: menus.children && menus.level === 2 ? chunk(menus.children.map((el) => ({
          ...el,
          children: null
        })), 5) : menus.children && menus.level === 3 ? menus.children.map((el) => ({
          ...el,
          children: el?.children ? chunk(el.children, 4) : null
        })) : null
      }
    },
    showStyle: function() {
      let style = {}
      if (this.show) {
        style = {
          display: 'block'
        }
      } else {
        style = {}
      }
      return style
    },
    showSecondMenu: function() {
      let style = {}
      if (this.show) {
        style = {
          display: 'flex',
          justifyContent: 'center'
        }
      } else {
        style = {}
      }
      return style
    },
    flexStyle() {
      let style = {}
      if (this.show) {
        style = {
          display: 'flex'
        }
      } else {
        style = {}
      }
      return style
    }
  },
  created() {
    this.handleGetSolutionMenu()
    this.links.forEach((el) => {
      if (el.includeLinks.includes(this.$route.path)) {
        this.hoverNavIndex = el.index
      }
    })
  },
  methods: {
    handleGetSolutionMenu() {
      getSolutionMenu().then(response => {
        const children = response.data.map(element => ({
          name: element.name,
          url: `/solution-case-del/${element.id}`
        }))
        const arrayList = children && children.map((item) => item.url)
        this.links[1].includeLinks = [...this.links[1].includeLinks, ...arrayList]
        this.menus[1].children = children
      })
    },
    handleShowFormModal(val) {
      this.showFreeTrial = val
    },
    handleNavHoverIndex(index) {
      if (typeof (index) === 'number') {
        this.hoverNavIndex = index
      }
    },
    handleShow(index) {
      this.show = true
      if (typeof (index) === 'number') {
        this.hoverNavIndex = index
        this.title = menus[index].name
        this.showMenu = menus[index]
      }
    },
    handleHide() {
      this.show = false
    },
    handleChoseFirst(index) {
      this.showSecondMenus = cloneDeep(menus[index].children)
      this.showSecondTitle = menus[index].name
      if (menus[index].level !== 1) {
        this.showSecond = true
      } else if (menus[index].url) {
        this.$router.push({ path: menus[index].url })
      }
    },
    handleChoseSecond(index) {
      const showSecondMenus = this.showSecondMenus[index]
      if (showSecondMenus.url) {
        this.handleChoseThird(showSecondMenus.url)
      } else {
        this.showThirdMenus = cloneDeep(showSecondMenus.children)
        this.showThirdTitle = showSecondMenus.name
        this.showThird = true
      }
    },
    handleChoseThird(url) {
      this.$router.push({ path: url })
    },
    handleScroll(e) {
      e.stopPropagation()
    },
    handleSwitchVideo(visible) {
      this.visible = visible
    }
  }
}
</script>

<style lang="scss" scoped>
.head-body {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .head-links {
    flex: 1;
    .head-up {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-top: 33px;
      & > * {
        margin-left: 20px;
      }
      .vertical {
        width: 1px;
        height: 35px;
        background-color: #c6c6c6;
      }
      .sale-phone {
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0px;
        color: #242424;
      }
      .contact-us {
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 19px;
        letter-spacing: 0px;
        color: #3d3491;
        cursor: pointer;
      }
    }
    .head-down {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-top: 26px;
      margin-bottom: 17px;
      .img-over {
        width: 120px;
        height: 50px;
        transform: translate(50px, 2px);
        // width: 217px;
        // height: 40px;
        // cursor: pointer;
      }
      .links {
        position: relative;
        display: flex;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333;
        width: 800px;
        & > div:not(.link-items) {
          transform: translate(0px, 17px);
          padding-right: 30px;
          padding-bottom: 26px;
          line-height: 18px;
          font-size: 18px;
          text-align: left;
          cursor: pointer;
          transition: all 0.3s ease;
          &::after {
            display: block;
            position: relative;
            content: '';
            transform: translate(0, 26px);
            width: 100%;
            height: 4px;
            background-color: transparent;
          }
        }
        .home-link {
          font-weight: bolder;
          transition: all 0.3s ease;
          color: #3d3491;
          &::after {
            display: block;
            position: relative;
            content: '';
            transform: translate(0, 26px);
            width: 100%;
            height: 4px;
            background-color: #3d3491 !important;
          }
        }
      }
      .free-trial {
        display: grid;
        place-items: center;
        width: 140px;
        height: 56px;
        background-color: #3d3491;
        border-radius: 8px;
        font-size: 18px;
        cursor: pointer;
        color: #fff;
      }
    }
  }
}
.second-menus {
  z-index: 100;
  display: none;
  position: absolute;
  left: 0;
  top: 151px;
	width: 100%;
	height: 360px;
	background-color: #fcfeff;
	box-shadow: 0px 0px 6px 0px#d9dde4;
	opacity: 0.9;
  transform: all 0.3 ease;
  .link-items {
    position: absolute;
    margin-top: 54px;
    z-index: 999;
    display: none;
    .item {
      display: flex;
      justify-content: space-around;
      // &:first-of-type {
      //   padding-right: 100px;
      // }
      &.item-column {
        display: flex;
        flex-direction: column;
      }
      // &.item-comminute {
      //   margin-bottom: 20px;
      //   overflow: hidden;
      // }
      .group-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        margin-right: 30px;
        .link-info {
          width: 141px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 30px;
          .icon-wrapper {
            width: 72px;
            padding: auto;
          }
          .text-normal {
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333;
            cursor: pointer;
            white-space: nowrap;
            transition: all 0.3s ease;
            &:hover {
              color: #3d3491;
            }
          }
        }
      }
      .text-title {
        margin-right: 35px;
        padding-bottom: 124px;
        padding-top: 114px;
        color: #333;
        font-size: 26px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        white-space: nowrap;
      }
    }
  }
  .menu-level-2-wrapper {
    position: absolute;
    margin-top: 78px;
    z-index: 999;
    display: none;
    .item {
      display: flex;
      float: left;
      padding-right: 100px;
      &.item-column {
        float: none;
        display: flex;
        flex-direction: column;
      }
      // &.item-comminute {
      //   margin-bottom: 20px;
      //   overflow: hidden;
      // }
      .menu-level-2 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        margin-right: 40px;
        .menu-item-wrapper {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 30px;
          .icon-normal {
            margin-right: 20px;
          }
          .text-normal {
            font-size: 18px;
            color: #333;
            cursor: pointer;
            white-space: nowrap;
            transition: all 0.3s ease;
            &:hover {
              color: #3d3491;
            }
          }
        }
      }
    }
  }
}
/deep/ .el-drawer {
  outline: none;
}
.video-body {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 99999;
  .back-shadow {
    height: 100%;
    width: 100%;
    background-color: #000;
    opacity: .5;
  }
  .video-show {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -450px;
    margin-top: -253px;
  }
  .close-body {
    position: absolute;
    left: 50%;
    margin-left: 400px;
    top: 50%;
    margin-top: -250px;
    height: 40px;
    width: 40px;
    background: url(../assets/home/close.png);
    z-index: 999999;
    cursor: pointer;
  }
  video {
    outline: none;
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: #333;
  opacity: 0.4;
}
@media screen and (max-width: 1200px) {
  .fix-body {
    position: fixed;
    width: 100%;
    top: 0;
    background-color: #fff;
    z-index: 2000;
    .navigation-mobile {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      .img-show {
        height: 40px;
        width: 34px;
      }
      .el-icon-s-fold {
        font-size: 30px;
        color: #3e3892;
      }
    }
  }
  .navigation-mobile {
    /deep/ .el-drawer__header {
      padding: 0;
      flex-direction: column;
      margin-bottom: 0;
    }
    .navigation-title {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      flex: 0 1 51px;
      color: #3e3892;
      border-bottom: 1px solid #ababab;
      padding: 0 20px;
      box-sizing: border-box;
      .el-icon-arrow-left {
        font-size: 22px;
      }
      .el-icon-close {
        font-size: 22px;
      }
    }
    .navigation-text {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      height: 50px;
      color: #3e3892;
      background-color: #f6f6f6;
      border-bottom: 1px solid #ababab;
      padding: 0 20px;
      box-sizing: border-box;
      .el-icon-arrow-right {
        font-size: 22px;
      }
    }
  }
}
</style>
